<div class="header-top">
  <div class="container topbar-content">
    <a href="tel:330-474-9507" class="topbar-phone">
      <mat-icon>phone</mat-icon>
      <span>Call Center</span>
      <strong>330-474-9507</strong>
    </a>

    <nav class="guest-links" aria-label="Driver and customer access" *ngIf="logedin == false">
      <a href="https://yodertoter.com/yoderadmin/driver/">Become a Driver</a>
      <a href="https://yodertoter.com/yoderadmin/driverlogin">Driver Login</a>
      <button type="button" (click)="openDialog()">Customer Login</button>
    </nav>
  </div>
</div>

<header class="navigation-wrap start-header start-style">
  <div class="container">
    <nav class="navbar navbar-expand-md navbar-light" aria-label="Primary navigation">
      <a class="brand-link" routerLink="./" aria-label="TruLink home">
        <img src="assets/images/logo.jpg" class="headerlogo img-fluid" alt="TruLink Transit LLC">
      </a>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto align-items-md-center">
          <li class="nav-item">
            <a class="nav-link navurl" routerLink="./" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link navurl" routerLink="./about" routerLinkActive="active-link">About</a>
          </li>
          <li class="nav-item">
            <a class="nav-link navurl" routerLink="./testimonials" routerLinkActive="active-link">Testimonials</a>
          </li>

          <li class="nav-item dropdown account-menu" *ngIf="logedin == true">
            <button class="nav-link account-toggle dropdown-toggle" type="button" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <span class="account-avatar"><mat-icon>person</mat-icon></span>
              <span class="account-copy">
                <small>My account</small>
                <strong>{{ cuname }}</strong>
              </span>
              <mat-icon class="account-chevron">expand_more</mat-icon>
            </button>
            <div class="dropdown-menu dropdown-menu-right account-dropdown">
              <p class="dropdown-heading">Customer account</p>
              <a class="dropdown-item navurl" routerLink="./my-bookings">
                <mat-icon>route</mat-icon><span>My bookings</span>
              </a>
              <a class="dropdown-item navurl" routerLink="./favourites">
                <mat-icon>favorite_border</mat-icon><span>Favourites</span>
              </a>
              <a class="dropdown-item navurl" routerLink="./wallet">
                <mat-icon>account_balance_wallet</mat-icon><span>Wallet</span>
              </a>
              <a class="dropdown-item navurl" routerLink="./my-profile">
                <mat-icon>manage_accounts</mat-icon><span>Profile</span>
              </a>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item logout-item" type="button" (click)="logout()">
                <mat-icon>logout</mat-icon><span>Log out</span>
              </button>
            </div>
          </li>

          <li class="nav-item header-action-item">
            <a class="header-action header-action--call" href="tel:330-474-9507">
              <mat-icon>phone</mat-icon>
              <span>Call</span>
            </a>
          </li>
          <li class="nav-item header-action-item">
            <a class="header-action header-action--book" routerLink="./">
              <mat-icon>add_road</mat-icon>
              <span>Book a ride</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</header>

<div class="preloader"></div>
